"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _numberFormatter = require("../../helpers/numberFormatter");
var useEstimatedTPSLValues = function useEstimatedTPSLValues(_ref) {
  var takeProfit = _ref.takeProfit,
    stopLoss = _ref.stopLoss,
    amount = _ref.amount,
    side = _ref.side,
    price = _ref.price,
    instrument = _ref.instrument;
  var estimatedProfitValue = (0, _react.useMemo)(function () {
    if (!takeProfit || !amount || !price) return '--';
    var profit = side === 'Long' ? amount * (takeProfit - price) : amount * (price - takeProfit);
    return (0, _numberFormatter.formatNumberToLocale)(profit, instrument === null || instrument === void 0 ? void 0 : instrument.Product2Symbol);
  }, [takeProfit, side, instrument === null || instrument === void 0 ? void 0 : instrument.Product2Symbol, amount, price]);
  var estimatedLossValue = (0, _react.useMemo)(function () {
    if (!stopLoss || !amount || !price) return '--';
    var loss = side === 'Long' ? amount * (stopLoss - price) : amount * (price - stopLoss);
    return (0, _numberFormatter.formatNumberToLocale)(loss, instrument === null || instrument === void 0 ? void 0 : instrument.Product2Symbol);
  }, [stopLoss, side, instrument === null || instrument === void 0 ? void 0 : instrument.Product2Symbol, amount, price]);
  return {
    estimatedProfitValue: estimatedProfitValue,
    estimatedLossValue: estimatedLossValue
  };
};
var _default = exports["default"] = useEstimatedTPSLValues;